import React from "react";
import { finished } from "../../assets/images";
import { useTranslation } from "react-i18next";

const Completed = () => {
  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language; // Aktif dili alıyoruz

  return (
    <div className="flex justify-center items-center py-[40px] md:py-[74px]">
      <div className="max-w-containerSm md:max-w-container mx-auto md:w-[562px] text-center">
        <img alt="Finished" className="w-[60px] mx-auto" src={finished}></img>
        <p className="text-[24px] md:text-[32px] font-bold mt-5">
          {t("Sifarişiniz təsdiq edildi!")}
        </p>
        <a href={`/${currentLanguage}/`}>
          <button className="w-[226px] h-[44px] bg-[#181D27] text-white rounded-[16px] mt-[30px] md:mt-[48px]">
            {t("Ana səhifəyə qayıt")}
          </button>
        </a>
      </div>
    </div>
  );
};

export default Completed;
